module.exports = __webpack_public_path__ + "966e2c2743490c068bbe64f9c0ab1009.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_rp_rating.png
// module id = 401
// module chunks = 0